/** Эффективный статус абонемента с учётом ends_at и остатка занятий. */
export function getEffectiveMembershipStatus(m) {
  if (!m) return null;
  if (m.status === "cancelled") return "cancelled";
  if (m.status === "pending") return "pending";
  if (m.status === "expired") return "expired";
  const today = new Date().toISOString().slice(0, 10);
  const ends = m.ends_at ? String(m.ends_at).slice(0, 10) : null;
  if (ends && ends < today) return "expired";
  if (m.visits_remaining != null && Number(m.visits_remaining) <= 0) {
    return "expired";
  }
  if (
    m.status === "frozen" ||
    (m.frozen_until && String(m.frozen_until).slice(0, 10) >= today)
  ) {
    return "frozen";
  }
  if (m.status === "active") return "active";
  return m.status;
}
